import React, { useEffect, useState } from 'react';

export const useShowColums = (columns) => {
    const [columnasVisibles, setColumnasVisibles] = useState(columns);
    const toggleCheck = (columnName) => {
        setColumnasVisibles((prevColumnasVisibles) => {
            return {
                ...prevColumnasVisibles,
                [columnName]: {
                    ...prevColumnasVisibles[columnName],
                    estado: !prevColumnasVisibles[columnName].estado,
                },
            };
        });
    };

    return {
        toggleCheck,
        columnasVisibles,
    };
};

export const useShowColumsHook = (initialColumns, table) => {
    const [columnasVisibles, setColumnasVisibles] = useState(initialColumns);

    useEffect(() => {
        localStorage.setItem(table, JSON.stringify(columnasVisibles));
    }, [columnasVisibles]);

    const toggleCheck = (columnName) => {
        setColumnasVisibles((prevColumnasVisibles) => ({
            ...prevColumnasVisibles,
            [columnName]: {
                ...prevColumnasVisibles[columnName],
                estado: !prevColumnasVisibles[columnName].estado,
            },
        }));
    };
    return {
        toggleCheck,
        columnasVisibles,
    };
};
